import { api } from "@breakout/backend/convex/_generated/api"
import type { Maybe } from "@breakout/shared/types/market"
import { convexQuery } from "@convex-dev/react-query"
import { useQuery } from "@tanstack/react-query"
import type { Address } from "viem"

interface UserPositionsEnhancedArgs {
	userAddress: Address
}

export function useUserPositionsEnhanced(args: Maybe<UserPositionsEnhancedArgs>) {
	return useQuery({
		...convexQuery(api.indexer.public.getUserPositionsEnhanced, {
			userAddress: args?.userAddress ?? "",
		}),
		enabled: !!args,
	})
}
